module.exports = __webpack_public_path__ + "img/a1776b5d0b1228f11b34a03a1b36c038.svg";